import { createAction, props, Action } from '@ngrx/store';
import { BreadcrumbModel } from './../models/breadcrumb.model';

export const updateBreadcrumb = createAction('[Breadcrumb] updateBreadcrumb', props<{payload: BreadcrumbModel}>());

export interface ActionWithBreadcrumb extends Action {
    payload: BreadcrumbModel;
}
